export const REACT_APP_BE_API_URL = import.meta.env.REACT_APP_BE_API_URL;
export const REACT_APP_BE_API_STATS_URL = import.meta.env
  .REACT_APP_BE_API_STATS_URL;

export const REACT_APP_ENV = import.meta.env.REACT_APP_ENV ?? 'local';
export const REACT_APP_SSO_AUTHORITY = import.meta.env.REACT_APP_SSO_AUTHORITY;
export const REACT_APP_SSO_AUTHORITY_DOMAIN = import.meta.env
  .REACT_APP_SSO_AUTHORITY_DOMAIN;

const ENV_REACT_APP_SSO_LOG_LEVEL = import.meta.env.REACT_APP_SSO_LOG_LEVEL;
export const REACT_APP_SSO_LOG_LEVEL = ENV_REACT_APP_SSO_LOG_LEVEL
  ? +ENV_REACT_APP_SSO_LOG_LEVEL
  : 4;
export const REACT_APP_SENTRY_DSN = import.meta.env.REACT_APP_SENTRY_DSN;
export const REACT_APP_SSO_CLIENT_ID = import.meta.env.REACT_APP_SSO_CLIENT_ID;
export const REACT_APP_SSO_REDIRECT_URL = import.meta.env
  .REACT_APP_SSO_REDIRECT_URL;
export const REACT_APP_SSO_SCOPES = import.meta.env.REACT_APP_SSO_SCOPES;
export const REACT_APP_VERSION = import.meta.env.REACT_APP_VERSION;
const rawSSOConfig = import.meta.env.REACT_APP_SSO_CONFIG_JSON;
let parsedSSOConfig = {};
try {
  parsedSSOConfig = rawSSOConfig ? JSON.parse(rawSSOConfig) : {};
} catch (error) {
  console.error('Failed to parse REACT_APP_SSO_CONFIG_JSON:', error);
}
export const SSO_CONFIG_OUTPUTS = parsedSSOConfig;

// Cognito custom identity-provider name used for the SSO redirect
// (`signInWithRedirect({ provider: { custom: SSO_CUSTOM_PROVIDER } })`).
export const SSO_CUSTOM_PROVIDER = 'transmedics-ad';

export const REACT_APP_API_FETCH_INTERVAL =
  Number(import.meta.env.REACT_APP_API_FETCH_INTERVAL) || 60;

export const EIGHT_HOURS = 8 * 60;
export const SIX_HOURS = 6 * 60;
export const FOUR_HOURS = 4 * 60;
export const TWO_HOURS = 2 * 60;

export const REACT_APP_LOGISTICS_BASE_URL = import.meta.env
  .REACT_APP_LOGISTICS_BASE_URL;
export const REACT_APP_BYPASS = import.meta.env.REACT_APP_BYPASS;

/**
 * Feature flag for External Reference parsing mode
 * - true (default): Supports both legacy and new format parsing
 * - false: Strict new format only (MX/, TRNG/, Repo/, Special/, or Mission with organ)
 */
export const EXTERNAL_REFERENCE_LEGACY_MODE =
  import.meta.env.REACT_APP_EXTERNAL_REFERENCE_LEGACY_MODE !== 'false';
